import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ScreenDetection from '../ScreenDetection';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import MobileBottomNavigation from './MobileBottomNavigation';
import './Navigation.css';
/**
 * ## Redux imports
 */
import { actions as routerActions } from 'react-router-redux';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';

class Navigation extends Component {
  state = {
    prevStep: '',
    nextStep: '',
  };

  observer = null;

  handleResize = () => {
    let element = document.getElementById('mobile-bottom-navigation');
    let mobileContainer = document.getElementById('mobile-container');
    let progressBar = document.getElementById('progress-bar');
    if (
      progressBar ||
      !element ||
      !element.getBoundingClientRect() ||
      !mobileContainer ||
      !mobileContainer.getBoundingClientRect()
    ) {
      return;
    }
    let mobileContainerInfo = mobileContainer.getBoundingClientRect();
    let topNavigationHeight = 36;
    let contentHeight = topNavigationHeight + mobileContainerInfo.height;

    if (contentHeight < window.innerHeight) {
      element.style.bottom = '0px';
      element.style.position = 'fixed';
    } else {
      element.style.position = 'relative';
    }

    this.setState({ rerender: true });
  };

  watchAllChildElements = (element, config) => {
    var childCount = element.childNodes ? element.childNodes.length : 0;

    if (childCount > 0) {
      for (var i = 0; i < childCount; i++) {
        let targetNode = element.childNodes[ i ];
        this.observer.observe(targetNode, config);
        this.watchAllChildElements(targetNode, config);
      }
    }
  };

  observeResize = () => {
    let targetNode = document.getElementById('mobile-container');
    // Options for the observer (which mutations to observe)
    let config = { attributes: true, childList: true };
    // Create an observer instance linked to the callback function
    this.observer = new MutationObserver(this.handleResize);
    // Start observing the target node for configured mutations
    this.observer.observe(targetNode, config);
    this.watchAllChildElements(targetNode, config);
  };

  componentWillUnmount () {
    if (document.getElementById('mobile-container') && this.observer) {
      this.observer.disconnect();
    }
  }

  componentWillReceiveProps (props) {
    const { activeStep, navigation } = this.props;
    if (activeStep) {
      let currentIndex = navigation.findIndex(step => step.id.toLowerCase() === activeStep);
      let prevStepIndex = currentIndex > 0 ? currentIndex - 1 : -1;
      let nextStepIndex = currentIndex < navigation.length ? currentIndex + 1 : navigation.length;
      let prevStep = navigation[ prevStepIndex ] ?
        navigation[ prevStepIndex ] :
        prevStepIndex === 0 ? { id: 'home' } : { id: '', enabled: true };
      let nextStep = navigation[ nextStepIndex ] ?
        navigation[ nextStepIndex ] :
        nextStepIndex === navigation.length ?
          { id: 'reservationsuccessful', enabled: true } :
          { id: '', enabled: true };
      this.setState({ prevStep, nextStep });

      if (
        !this.state.resized &&
        document.getElementById('mobile-container') &&
        !document.getElementById('progress-bar')
      ) {
        this.setState({ resized: true });
        this.observeResize();
      }
    }
  }

  /**
   * change step
   * @param {String} step - new step ID
   * @param {String} type - '+' or '-' to go previous or next step
   */
  changeStep = step => {
    const { submitData } = this.props;
    if (submitData) {
      submitData(step);
    }
  };

  render () {
    const { navigation, location } = this.props;
    const { prevStep, nextStep } = this.state;
    let currentLocation = location && location.pathname ? location.pathname : '';
    if (!navigation || !navigation.length) return null;

    return (
      <div className='full-height'>
        <div className='navigation'>
          <ScreenDetection
            desktopScreen={
              <DesktopNavigation
                navigation={navigation}
                currentLocation={currentLocation}
                onClick={this.changeStep}
                prevStep={prevStep}
                nextStep={nextStep}
                exit='https://www.kona-shuttle.com/crm_beta/'
              />
            }
            mobileScreen={
              <MobileNavigation
                navigation={navigation}
                currentLocation={currentLocation}
                onClick={this.changeStep}
                prevStep={prevStep}
                exit='https://www.kona-shuttle.com/crm_beta/'
              />
            }
          />
        </div>
        {this.props.screen}
        <ScreenDetection
          desktopScreen={null}
          mobileScreen={
            <MobileBottomNavigation
              navigation={navigation}
              currentLocation={currentLocation}
              onClick={this.changeStep}
              nextStep={nextStep}
            />
          }
        />
      </div>
    );
  }
}

Navigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.object,
  submitData: PropTypes.func,
  activeStep: PropTypes.string,
  screen: PropTypes.object,
};

/**
 * ## Redux boilerplate
 */
const actions = [ routerActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    navigation: selectors.navigation.getNavigation(state.navigation),
    activeStep: selectors.global.activeStep(state.global),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navigation));



// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.js